module.exports = __webpack_public_path__ + "ecomondo_news-foto-4.jpg?8b638779cd1390baf1a41456a8e8ecd0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecomondo_news-foto-4.jpg
// module id = 183
// module chunks = 0